import React from 'react'
import { scrollToTarget } from './sfc/component-helpers/scrolldownhelpers'
import WCMImage from './sfc/wcmimage'

let athlete_list = require('../data/athletes.sheet.json')
athlete_list = athlete_list.filter(i => i.Page_Date.length > 0)

const AthleteCard = ({setAthlete, athleteName, athleteSport, athleteSchool, voted, wcm, stats, bio, winner, voting_closed, theme_color, attribution}) => {
    const handleClick = () => {
        setAthlete(athlete_list.find(({Name}) => Name === athleteName))
        scrollToTarget("#aotw-vote-module")
    }
    return(
        <div className={winner == 'TRUE' ? 'athlete-card aotw-card-winner' : 'athlete-card'} style={winner == 'TRUE' ? {backgroundColor: theme_color} : {backgroundColor: "#F6F6F6"}}>
            {winner == 'TRUE' && <h2><strong>Winner: {athleteName}</strong></h2>}
            {winner == 'FALSE' && <h2><strong>{athleteName}</strong></h2>}
            <h2 className='athlete-details-final'>{athleteSport} | {athleteSchool}</h2>
            {wcm && <WCMImage wcm={wcm} alt={"Photo of " + athleteName} className="athlete-card-photo"/>}
            <figcaption>{attribution}</figcaption>
            <p className="athlete-stats" dangerouslySetInnerHTML={{__html: stats}} />
            <p className="athlete-bio" dangerouslySetInnerHTML={{__html: bio}} />
            {/* {!voting_closed && <button onClick={() => {handleClick()}}>{"Vote for " + athleteName}</button>} */}
            {(!voting_closed && !voted) && <button className='devhub-ga-tracking' id={athleteName + "-votebutton"}style={{backgroundColor: theme_color}}onClick={() => {handleClick()}}>{"Vote for " + athleteName}</button>}
        </div>
    )
}
export default AthleteCard
